import React from "react"
import { Line } from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"

// Register required components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

const SalesChart = ({ data }) => {
  const chartData = {
    labels: data.map((entry) => entry.sale_date), // Dates on the x-axis
    datasets: [
      {
        label: "Total Sales",
        data: data.map((entry) => entry.total_sales), // Sales values
        borderColor: "#42A5F5",
        backgroundColor: "rgba(66, 165, 245, 0.2)",
        tension: 0.4,
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: { display: true },
    },
    scales: {
      x: { title: { display: true, text: "Date" } },
      y: { title: { display: true, text: "Total Sales" } },
    },
  }

  return <Line data={chartData} options={options} />
}

export default SalesChart
